import { createRef, Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import withStyles from 'beam/dist/styles'
import SilenceEvent from './SilenceEvent'
import SpeechBubble from './SpeechBubble'
import { AutoSizer } from 'react-virtualized'
import { footerMaxWidth, footerMargin } from '../../../Common/Footer'
import { SCROLL_ALIGNMENT_FRACTION } from '../MediaPlayer/helpers'

const styles = theme => ({
  root: {
    flex: '1 1 auto',
    overflowY: 'auto',
    height: '100%',
    '@media print': {
      overflow: 'visible',
    },
  },
  bubbleContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'hidden',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    position: 'relative',
  },
})

/**
 * This could be a functional component, even declared inline in `Transcription.js`,
 * however to make the print work, it must be a component
 */
class TranscriptionBody extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    currentTime: PropTypes.number.isRequired,
    setTime: PropTypes.func.isRequired,
    audioOffset: PropTypes.number.isRequired,
    queryCurrentIndex: PropTypes.number.isRequired,
    silenceEventDuration: PropTypes.number.isRequired,
    bubbles: PropTypes.array.isRequired,
    theme: PropTypes.shape({
      spacing: PropTypes.any,
    }),
  }

  rootRef = createRef()

  render() {
    const {
      theme,
      classes,
      currentTime,
      setTime,
      silenceEventDuration,
      audioOffset,
      queryCurrentIndex,
      bubbles,
    } = this.props
    let lastEnd = audioOffset

    const tableHeight =
      window.innerHeight -
      theme.spacing(6 + 8 + 4) - // navbar + media player header + transcription panel header
      theme.spacing(2) - // footer
      (window.innerWidth <= footerMaxWidth ? footerMargin : 0) // footer could have a bottom margin if the scroll bar pops up

    return (
      <div className={classes.root} ref={this.rootRef}>
        <AutoSizer disableWidth defaultHeight={tableHeight} style={{ height: 'auto' }}>
          {({ height }) => {
            //Give top and bottom padding so we can scroll and ensure that the transcription bubble can always be in the middle
            const paddingAmount = height / SCROLL_ALIGNMENT_FRACTION
            const containerPaddingTop = `${paddingAmount}px`
            const containerPaddingBottom = `${height - paddingAmount}px`

            return (
              <div
                className={classes.bubbleContainer}
                style={{ paddingTop: containerPaddingTop, paddingBottom: containerPaddingBottom }}
                data-testid="TranscriptionBody-div-bubbleContainer"
              >
                {/*Don't render transcriptions until the height has been determined*/}
                {height &&
                  bubbles.map(text => {
                    const silenceDuration = text.start - lastEnd
                    const hasSilenceEvent = silenceDuration > silenceEventDuration
                    lastEnd = text.end
                    return (
                      <Fragment key={`${text.channel}-${text.start}`}>
                        {hasSilenceEvent && <SilenceEvent duration={silenceDuration} />}
                        <SpeechBubble
                          setTime={setTime}
                          currentTime={currentTime}
                          sentiment={text.sentiment}
                          start={text.start}
                          end={text.end}
                          channel={text.channel}
                          clumps={text.clumps}
                          queryCurrentIndex={queryCurrentIndex}
                          scrollElement={this.rootRef.current ? this.rootRef.current : null}
                        />
                      </Fragment>
                    )
                  })}
              </div>
            )
          }}
        </AutoSizer>
      </div>
    )
  }
}

export default withStyles(styles, { withTheme: true })(TranscriptionBody)
